<script lang="ts">import { Container } from "@infinitro/container";
import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import "../api/api";
export let race;
export let raceId = undefined;
</script>

<Container width="56.25rem">
	<div class="participating-games">
		<div class="participating-games-title">
			<Text
				type="title"
				titleWeight="bold"
				customStyle="font-size: 2rem !important; line-height: 2.5rem !important;"
				textAlign="center"
			>
				{$t(Verbiage.participating_games_title)}
			</Text>
		</div>

		<InfoCard width="100%">
			<div class="participating-games-text">
				<Text
					type="body"
					bodyWeight="bold"
					customStyle="font-size: 1rem !important; line-height: 2.5rem !important; color: #FFCE2B !important;"
					textAlign="center"
				>
					{@html $t(Verbiage.participating_games)}
				</Text>
			</div>
		</InfoCard>
	</div>
</Container>

<style>
	.participating-games {
    width: 100%
}
	.participating-games-title {
    margin-top: 1rem;
    margin-bottom: 1rem;
    text-transform: uppercase
}

	.participating-games-text {
    width: 100%;
    border-radius: 0.5rem;
    --tw-bg-opacity: 1;
    background-color: rgb(26 38 88 / var(--tw-bg-opacity, 1));
    text-align: center;
    text-transform: uppercase
}
</style>
